import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

class StaffNeededTrainingsOldModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      show_other: false,
      staff_needed_training_id: this.props.data_modal_old.staff_needed_training_id,
      date: this.props.data_modal_old.date,
      motivo: this.props.data_modal_old.motivo,
      other_reason: this.props.data_modal_old.other_reason,
      conhecimento_analise: this.props.data_modal_old.conhecimento_analise,
      outras_atividades: this.props.data_modal_old.outras_atividades,
      print_integracao: this.props.data_modal_old.print_integracao,
      print_geral: this.props.data_modal_old.print_geral,
      print_sup: this.props.data_modal_old.print_sup,
      print_fer: this.props.data_modal_old.print_fer,
      print_mnt: this.props.data_modal_old.print_mnt,
      print_eng: this.props.data_modal_old.print_eng,
      print_ctm: this.props.data_modal_old.print_ctm,
      print_sasc: this.props.data_modal_old.print_sasc,
      print_qua: this.props.data_modal_old.print_qua,
      print_inspetores: this.props.data_modal_old.print_inspetores,
      print_rampa: this.props.data_modal_old.print_rampa,
      apoio_corrosao: this.props.data_modal_old.apoio_corrosao,
      apoio_pbn: this.props.data_modal_old.apoio_pbn,
      apoio_hums1: this.props.data_modal_old.apoio_hums1,
      apoio_hums2: this.props.data_modal_old.apoio_hums2,
      apoio_ingles: this.props.data_modal_old.apoio_ingles,
      apoio_boroscopia: this.props.data_modal_old.apoio_boroscopia,
      apoio_fatores_humanos: this.props.data_modal_old.apoio_fatores_humanos,
      apoio_orientacao_pedagogica: this.props.data_modal_old.apoio_orientacao_pedagogica,
      apoio_artigos_perigosos: this.props.data_modal_old.apoio_artigos_perigosos,
      apoio_eos: this.props.data_modal_old.apoio_eos,
      staff_id: this.props.data_modal_old.staff_id,
      modal_old: false,
      aeronaves: null,
      motores: null,
      oficinas: null,
      funcao: null,
      organizacao: null,
      periodo: null,
      staff_needed_training_items: {},
      staff_needed_trainings: this.props.data_modal_old,
    };

    this.edit = this.edit.bind(this);
    this.addItemProduct = this.addItemProduct.bind(this);
    this.addItemKnowledge = this.addItemKnowledge.bind(this);
    this.deleteItemKnowledge = this.deleteItemKnowledge.bind(this);
    this.deleteItemProduct = this.deleteItemProduct.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    if (event.value === 'Outro') {
      this.setState({show_other: true});
    } else {
      this.setState({show_other: false});
    }
  }

  handleCheckboxChange (name, event) {
    var change = {};
    if(event.target.checked == true) {
      change[event.target.name] = true;
    } else {
      change[event.target.name] = false;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.data_modal_old.staff_needed_training_items)) {
      this.setState({
        data_modal_old: newProps.data_modal_old,
        staff_needed_training_id: newProps.data_modal_old.id,
        date: newProps.data_modal_old.date_str,
        motivo: newProps.data_modal_old.motivo,
        other_reason: newProps.data_modal_old.other_reason,
        conhecimento_analise: newProps.data_modal_old.conhecimento_analise,
        outras_atividades: newProps.data_modal_old.outras_atividades,
        conhecimento_analise: newProps.data_modal_old.conhecimento_analise,
        print_integracao: newProps.data_modal_old.print_integracao,
        print_geral: newProps.data_modal_old.print_geral,
        print_sup: newProps.data_modal_old.print_sup,
        print_fer: newProps.data_modal_old.print_fer,
        print_mnt: newProps.data_modal_old.print_mnt,
        print_eng: newProps.data_modal_old.print_eng,
        print_ctm: newProps.data_modal_old.print_ctm,
        print_sasc: newProps.data_modal_old.print_sasc,
        print_qua: newProps.data_modal_old.print_qua,
        print_inspetores: newProps.data_modal_old.print_inspetores,
        print_rampa: newProps.data_modal_old.print_rampa,
        apoio_corrosao: newProps.data_modal_old.apoio_corrosao,
        apoio_pbn: newProps.data_modal_old.apoio_pbn,
        apoio_hums1: newProps.data_modal_old.apoio_hums1,
        apoio_hums2: newProps.data_modal_old.apoio_hums2,
        apoio_ingles: newProps.data_modal_old.apoio_ingles,
        apoio_boroscopia: newProps.data_modal_old.apoio_boroscopia,
        apoio_fatores_humanos: newProps.data_modal_old.apoio_fatores_humanos,
        apoio_orientacao_pedagogica: newProps.data_modal_old.apoio_orientacao_pedagogica,
        apoio_artigos_perigosos: newProps.data_modal_old.apoio_artigos_perigosos,
        apoio_eos: newProps.data_modal_old.apoio_eos,
        staff_id: newProps.data_modal_old.staff_id,
        staff_needed_training_items: newProps.data_modal_old.staff_needed_training_items,
        staff_needed_trainings: newProps.staff_needed_trainings,
        loaded: 1,
      });

      if (newProps.data_modal_old.motivo === 'Outro') {
      }
    }
    this.setState({modal_old: newProps.modal_old});
  }
  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.staff_needed_training_id,
      date: this.state.date,
      outras_atividades: this.state.outras_atividades,
      conhecimento_analise: this.state.conhecimento_analise,
      motivo: this.state.motivo,
      other_reason: this.state.other_reason,
      print_integracao: this.state.print_integracao,
      print_geral: this.state.print_geral,
      print_sup: this.state.print_sup,
      print_fer: this.state.print_fer,
      print_mnt: this.state.print_mnt,
      print_eng: this.state.print_eng,
      print_ctm: this.state.print_ctm,
      print_sasc: this.state.print_sasc,
      print_qua: this.state.print_qua,
      print_inspetores: this.state.print_inspetores,
      print_rampa: this.state.print_rampa,
      apoio_corrosao: this.state.apoio_corrosao,
      apoio_pbn: this.state.apoio_pbn,
      apoio_hums1: this.state.apoio_hums1,
      apoio_hums2: this.state.apoio_hums2,
      apoio_ingles: this.state.apoio_ingles,
      apoio_boroscopia: this.state.apoio_boroscopia,
      apoio_fatores_humanos: this.state.apoio_fatores_humanos,
      apoio_orientacao_pedagogica: this.state.apoio_orientacao_pedagogica,
      apoio_artigos_perigosos: this.state.apoio_artigos_perigosos,
      apoio_eos: this.state.apoio_eos,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador/necessidade/treinamento/novo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({staff_needed_trainings: responseJson.data});
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addItemKnowledge(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_needed_training_id: this.state.staff_needed_training_id,
      staff_id: this.state.staff_id,
      funcao: this.state.funcao,
      organizacao: this.state.organizacao,
      periodo: this.state.periodo,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador/necessidade/treinamento/item/conhecimento/novo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items});
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addItemProduct(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_needed_training_id: this.state.staff_needed_training_id,
      staff_id: this.state.staff_id,
      aeronaves: this.state.aeronaves,
      motores: this.state.motores,
      oficinas: this.state.oficinas,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/colaborador/necessidade/treinamento/item/produto/novo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items});
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  deleteItemKnowledge(staff_needed_training_item_id) {
    if (window.confirm('Tem certeza que gostaria de deletar esse item?')) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/colaborador/necessidade/treinamento/item/' + staff_needed_training_item_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items});
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteItemProduct(staff_needed_training_item_id) {
    if (window.confirm('Tem certeza que gostaria de deletar esse item?')) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/colaborador/necessidade/treinamento/item/' + staff_needed_training_item_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items});
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Modal show={this.state.modal_old} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Editar necessidade de treinamento</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { this.props.closeModalOld(self.state.staff_needed_trainings) }}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.edit}>
        <div className="row form-group">
          <div className="col-md-12 form-group">
            <label>Data:</label>
            <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
          </div>
        </div>
        <div className="row form-group">
          <div className="col-md-6 form-group">
            <label>Conhecimento e treinamento:</label>
            <textarea name="conhecimento_analise" className="form-control" value={this.state.conhecimento_analise} onChange={this.handleChange.bind(this, 'conhecimento_analise')} style={{ height: 200 }} />
          </div>
          <div className="col-md-6 form-group">
            <label>Outras atividades:</label>
            <textarea name="outras_atividades" className="form-control" value={this.state.outras_atividades} onChange={this.handleChange.bind(this, 'outras_atividades')} style={{ height: 200 }} />
          </div>
        </div>
        <hr/>
        <h4>Procedimentos internos</h4>
        <hr/>
        <div className="row form-group">
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_integracao"
                type="checkbox"
                checked={self.state.print_integracao}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_integracao)} />
              &nbsp;&nbsp;Integração
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_geral"
                type="checkbox"
                checked={self.state.print_geral}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_geral)} />
              &nbsp;&nbsp;Geral
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_sup"
                type="checkbox"
                checked={self.state.print_sup}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_sup)} />
              &nbsp;&nbsp;SUP
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_fer"
                type="checkbox"
                checked={self.state.print_fer}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_fer)} />
              &nbsp;&nbsp;FER
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_mnt"
                type="checkbox"
                checked={self.state.print_mnt}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_mnt)} />
              &nbsp;&nbsp;MNT
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_eng"
                type="checkbox"
                checked={self.state.print_eng}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_eng)} />
              &nbsp;&nbsp;ENG
            </label>
          </div>
        </div>
        <div className="row form-group">
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_ctm"
                type="checkbox"
                checked={self.state.print_ctm}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_ctm)} />
              &nbsp;&nbsp;CTM
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_sasc"
                type="checkbox"
                checked={self.state.print_sasc}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_sasc)} />
              &nbsp;&nbsp;SASC
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_qua"
                type="checkbox"
                checked={self.state.print_qua}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_qua)} />
              &nbsp;&nbsp;QUA
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_inspetores"
                type="checkbox"
                checked={self.state.print_inspetores}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_inspetores)} />
              &nbsp;&nbsp;Inspetores
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_rampa"
                type="checkbox"
                checked={self.state.print_rampa}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_rampa)} />
              &nbsp;&nbsp;Rampa
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="print_eng"
                type="checkbox"
                checked={self.state.print_eng}
                onChange={self.handleCheckboxChange.bind(self, self.state.print_eng)} />
              &nbsp;&nbsp;ENG
            </label>
          </div>
        </div>
        <hr/>
        <h4>Apoio</h4>
        <hr/>
        <div className="row form-group">
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_corrosao"
                type="checkbox"
                checked={self.state.apoio_corrosao}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_corrosao)} />
              &nbsp;&nbsp;Corrosão
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_pbn"
                type="checkbox"
                checked={self.state.apoio_pbn}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_pbn)} />
              &nbsp;&nbsp;PBN
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_hums1"
                type="checkbox"
                checked={self.state.apoio_hums1}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_hums1)} />
              &nbsp;&nbsp;HUMS Nível 1
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_hums2"
                type="checkbox"
                checked={self.state.apoio_hums2}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_hums2)} />
              &nbsp;&nbsp;HUMS Nível 2
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_ingles"
                type="checkbox"
                checked={self.state.apoio_ingles}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_ingles)} />
              &nbsp;&nbsp;Inglês
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_boroscopia"
                type="checkbox"
                checked={self.state.apoio_boroscopia}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_boroscopia)} />
              &nbsp;&nbsp;Boroscopia
            </label>
          </div>
        </div>
        <div className="row form-group">
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_fatores_humanos"
                type="checkbox"
                checked={self.state.apoio_fatores_humanos}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_fatores_humanos)} />
              &nbsp;&nbsp;Fatores Humanos
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_orientacao_pedagogica"
                type="checkbox"
                checked={self.state.apoio_orientacao_pedagogica}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_orientacao_pedagogica)} />
              &nbsp;&nbsp;Orientação<br/>Pedagógica
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_artigos_perigosos"
                type="checkbox"
                checked={self.state.apoio_artigos_perigosos}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_artigos_perigosos)} />
              &nbsp;&nbsp;Artigos Perigosos
            </label>
          </div>
          <div className="col-md-2 form-group">
            <label>
              <input
                name="apoio_eos"
                type="checkbox"
                checked={self.state.apoio_eos}
                onChange={self.handleCheckboxChange.bind(self, self.state.apoio_eos)} />
              &nbsp;&nbsp;EOS
            </label>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Gerar formulário</button>
      </form>
      <hr/>
      <h4>Treinamentos de produtos</h4>
      <hr/>
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="text-center">Aeronaves</th>
            <th className="text-center">Motores</th>
            <th className="text-center">Oficinas</th>
            <th className="col-md-3 text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(self.state.staff_needed_training_items).map(function(k) {
            if (self.state.staff_needed_training_items[k].type === 'produto') {
              return (
                <tr>
                  <td className="text-center">{self.state.staff_needed_training_items[k].aeronaves}</td>
                  <td className="text-center">{self.state.staff_needed_training_items[k].motores}</td>
                  <td className="text-center">{self.state.staff_needed_training_items[k].oficinas}</td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-danger" onClick={() => {self.deleteItemKnowledge(self.state.staff_needed_training_items[k].id);}}><i className="fa fa-fw fa-trash"></i></button>
                  </td>
                </tr>
              );
            } else {
              return '';
            }
          })}
        </tbody>
      </table>
      <hr/>
      <form onSubmit={this.addItemProduct}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>Aeronaves:</label>
            <textarea name="aeronaves" className="form-control" value={this.state.aeronaves} onChange={this.handleChange.bind(this, 'aeronaves')} style={{ height: 80 }} />
          </div>
          <div className="col-md-4 form-group">
            <label>Motores:</label>
            <textarea name="motores" className="form-control" value={this.state.motores} onChange={this.handleChange.bind(this, 'motores')} style={{ height: 80 }} />
          </div>
          <div className="col-md-4 form-group">
            <label>Oficinas:</label>
            <textarea name="oficinas" className="form-control" value={this.state.oficinas} onChange={this.handleChange.bind(this, 'oficinas')} style={{ height: 80 }} />
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar item</button>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => { this.props.closeModalOld(self.state.staff_needed_trainings) }}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default StaffNeededTrainingsOldModal;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffNeededTrainingsOldModal.js